<div>
  <table class="m-table" aria-label="Highlights" style="width: calc(100% - 1.5rem)">
    <thead style="border-bottom: 1px solid black;">
    <tr>
      <th><span class="table-header">{{ "HARSH_DRIVING_EVENT.dateTime" | translate }}</span></th>
      <th><span class="table-header">{{ "HARSH_DRIVING_EVENT.licencePlate" | translate }}</span></th>
      <th><span class="table-header">{{ "HARSH_DRIVING_EVENT.classification" | translate }}</span></th>
      <th><span class="table-header">{{ "HARSH_DRIVING_EVENT.severity" | translate }}</span></th>
      <th><span class="table-header">{{ "HARSH_DRIVING_EVENT.gpsPosition" | translate }}</span></th>
    </tr>
    </thead>
    <tbody>
      @for (incident of harshDrivingEvents?.incidents; track incident.messageId) {
        <tr>
          <td><span> {{ incident.timestamp | dateConversion }}</span></td>
          <td><span> {{ incident.licencePlate }}</span></td>
          <td><span> {{ "HARSH_DRIVING_EVENT." + incident.classification | translate }}</span></td>
          <td><span> {{ "HARSH_DRIVING_EVENT." + incident.severity | translate }}</span></td>
          <td>
            <a class="icon-class-style" style="text-decoration: none"
              href="https://www.google.com/maps/search/?api=1&query={{ incident.vehicleLocation.latitude }},{{ incident.vehicleLocation.longitude }}"
              target="_blank"
              rel="noopener"
            >
              {{ incident.vehicleLocation.latitude | dms:'lat' }} {{ incident.vehicleLocation.longitude | dms:'lng' }}
            </a>
          </td>
        </tr>
      }
    </tbody>
  </table>
  <div #scrollSentinel style="height: 10px; visibility: hidden;"></div>
</div>

<ngx-spinner
  bdColor="rgba(216,216,216,0.8)"
  fullScreen="true"
  template="
    <div style='display: flex; justify-content: center; align-items: center; height: 100%; width: 100%;'>
      <img src='{{ host }}/assets/loader/loader.gif' style='width: 100px; height: auto;' />
    </div>
  "
></ngx-spinner>
